<div class="widget-box">
  <div id="intro-answerquestions">
    <div class="intro-header">
      <button
        mat-icon-button
        type="button"
        class="intro-toggle"
        [attr.aria-label]="introExpanded ? 'Collapse' : 'Expand'"
        (click)="toggleIntro()"
      >
        <mat-icon>{{ introExpanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
      </button>
      <span>Instructions</span>
    </div>
    @if (introExpanded) {
    <p>
      Use the following General Applicability Checklist to determine whether a
      rulebook and its sections apply to your operation.
    </p>
    <p>
      If you answer YES to the rulebook question, the rulebook applies to you
      unless you answer YES for a rulebook exemption.
    </p>
    <p>
      Once you determine that the rulebook does apply to your operation, you
      must answer the section questions. If a section question does not exist,
      then that section applies if the rulebook applies. If you answer YES to a
      section question, that section applies to you unless you answer YES for an
      exemption from that section. If you answer YES to a rulebook or section
      exemption, then the rulebook or section does not apply.
    </p>
    }
  </div>
  @if (appSect$ | async; as acs) {
  <div class="answer-question">
    <div class="widget-header">
      <h4>{{ this.rbName }}</h4>
    </div>
    <div class="widget-body">
      @if (acs[0].rbSectNum == 0) {
      <mat-card
        class="card-demo section-app"
        [ngClass]="{ notAnswered: acs[0].answerQ == 'I' }"
      >
        <mat-card-title><h6>Rulebook Question</h6></mat-card-title>
        <mat-card-content class="large">
          <div fxLayout="column" fxFill>
            <div fxLayout fxFlex class="applicability">
              <div
                class="one"
                fxFlex="83.3"
                [innerHTML]="acs[0].question.trim()"
              ></div>
              @if (acs[0].sigChangeUpdate) {
              <div class="sig-change-icon" fxFlex="0 0 auto">
                <button
                  mat-icon-button
                  matTooltip="Significant change - click to view what changed"
                  matTooltipClass="tooltip2"
                  (click)="onViewSigChange(acs[0], $event)"
                >
                  <mat-icon fontSet="material-icons-outlined" class="sigChangeReview"
                    >warning</mat-icon
                  >
                </button>
              </div>
              }
              <div class="two" fxFlex="26.7" fxLayoutAlign="end start">
                <button
                  id="s"
                  class="btn btn-audit btn-light Y"
                  [ngClass]="{ 'btn-selected': acs[0].answerQ == 'Y' }"
                  data-qtype="rulebook"
                  type="button"
                  [disabled]="isLoading || !editable || acs[0].answerQ == 'Y'"
                  (click)="answerRbAppQ(0, 'Y')"
                >
                  Yes
                </button>
                <button
                  mat-button
                  id="s"
                  class="btn btn-audit btn-light N"
                  [ngClass]="{ 'btn-selected': acs[0].answerQ == 'N' }"
                  data-qtype="rulebook"
                  type="button"
                  [disabled]="isLoading || !editable || acs[0].answerQ == 'N'"
                  (click)="answerRbAppQ(0, 'N')"
                >
                  No
                </button>
              </div>
            </div>
          </div>
          @if (acs[0].exemption != null && acs[0].answerQ == 'Y') {
          <div fxLayout="column" fxFill class="exemption-block">
            <div fxLayout fxFlex class="applicability">
              <div
                class="one"
                fxFlex="83.3"
                [innerHTML]="acs[0].exemption"
              ></div>
              <div class="two" fxFlex="26.7" fxLayoutAlign="end start">
                <button
                  mat-button
                  id="s"
                  class="btn btn-audit Y"
                  [ngClass]="{
                    'btn-selected': acs[0].answerE.toLocaleString() == 'y'
                  }"
                  data-qtype="rulebook"
                  type="button"
                  [disabled]="
                    isLoading ||
                    !editable ||
                    acs[0].answerE.toLocaleString() == 'y'
                  "
                  (click)="answerRbAppE(0, 'y')"
                >
                  Yes
                </button>
                <button
                  mat-button
                  id="s"
                  class="btn btn-audit N"
                  [ngClass]="{
                    'btn-selected': acs[0].answerE.toLocaleString() == 'n'
                  }"
                  data-qtype="rulebook"
                  type="button"
                  [disabled]="
                    isLoading ||
                    !editable ||
                    acs[0].answerE.toLocaleString() == 'n'
                  "
                  (click)="answerRbAppE(0, 'n')"
                >
                  No
                </button>
              </div>
            </div>
          </div>
          }
        </mat-card-content>
        <mat-card-footer class="bottomPad">
          <div class="hint"></div>
        </mat-card-footer>
      </mat-card>
      } @if (acs[0].answerQ == 'Y' && acs[0].answerE.toLocaleString() != 'y') {
      @if (noQuestionSections$ | async; as noQSections) {
      @let mergedRows = mergeSections(acs, noQSections);
      @if (mergedRows.length > 0) {
      <mat-card class="card-demo section-app">
        <mat-card-title>
          <h6>Section Question</h6>
          @if (acs.length > 2) {
          <mat-toolbar color="primary" class="all-button-line">
            <button
              mat-button
              [disabled]="isLoading || !editable"
              (click)="answerToAll('Y')"
            >
              Yes to All
            </button>
            <button
              mat-button
              [disabled]="isLoading || !editable"
              (click)="answerToAll('N')"
            >
              No to All
            </button>
            <button
              mat-button
              [disabled]="isLoading || !editable"
              (click)="answerToAll('I')"
            >
              Clear All
            </button>
          </mat-toolbar>
          }
        </mat-card-title>
        @for (row of mergedRows; track row.rbSectKey + '-' + (row.ac ? 'q' : 'p')) {
        <mat-card-content class="large">
          <mat-card
            class="section-item"
            [ngClass]="{ notAnswered: row.ac?.answerQ == 'I' }"
          >
            <mat-card-title
              >Section {{ row.rbSectNum }} - {{ row.rbSectName }}</mat-card-title
            >
            <mat-card-content class="large">
              @if (row.ac; as ac) {
              <div fxLayout="column" fxFill>
                <div fxLayout fxFlex class="applicability">
                  <div
                    class="one"
                    fxFlex="83.3"
                    [innerHTML]="ac.question.trim()"
                  ></div>
                  @if (ac.sigChangeUpdate) {
                  <div class="sig-change-icon" fxFlex="0 0 auto">
                    <button
                      mat-icon-button
                      matTooltip="Significant change - click to view what changed"
                      matTooltipClass="tooltip2"
                      (click)="onViewSigChange(ac, $event)"
                    >
                      <mat-icon fontSet="material-icons-outlined" class="sigChangeReview"
                        >warning</mat-icon
                      >
                    </button>
                  </div>
                  }
                  <div class="two" fxFlex="26.7" fxLayoutAlign="end start">
                    <button
                      mat-button
                      id="s"
                      class="btn btn-audit btn-light Y"
                      [ngClass]="{ 'btn-selected': ac.answerQ == 'Y' }"
                      data-qtype="rulebook"
                      type="button"
                      [disabled]="isLoading || !editable || ac.answerQ == 'Y'"
                      (click)="answerRbAppQ(acs.indexOf(ac), 'Y')"
                    >
                      Yes
                    </button>
                    <button
                      mat-button
                      id="s"
                      class="btn btn-audit btn-light N"
                      [ngClass]="{ 'btn-selected': ac.answerQ == 'N' }"
                      data-qtype="rulebook"
                      type="button"
                      [disabled]="isLoading || !editable || ac.answerQ == 'N'"
                      (click)="answerRbAppQ(acs.indexOf(ac), 'N')"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
              @if (ac.exemption != null && ac.answerQ == 'Y') {
              <div fxLayout="column" fxFill class="exemption-block">
                <div fxLayout fxFlex class="applicability">
                  <div
                    class="one"
                    fxFlex="83.3"
                    [innerHTML]="ac.exemption"
                  ></div>
                  <div class="two" fxFlex="26.7" fxLayoutAlign="end start">
                    <button
                      mat-button
                      id="s"
                      class="btn btn-audit btn-light Y"
                      [ngClass]="{
                        'btn-selected': ac.answerE.toLocaleString() == 'y'
                      }"
                      data-qtype="rulebook"
                      type="button"
                      [disabled]="
                        isLoading ||
                        !editable ||
                        ac.answerE.toLocaleString() == 'y'
                      "
                      (click)="answerRbAppE(acs.indexOf(ac), 'y')"
                    >
                      Yes
                    </button>
                    <button
                      mat-button
                      id="s"
                      class="btn btn-audit btn-light N"
                      [ngClass]="{
                        'btn-selected': ac.answerE.toLocaleString() == 'n'
                      }"
                      data-qtype="rulebook"
                      type="button"
                      [disabled]="
                        isLoading ||
                        !editable ||
                        ac.answerE.toLocaleString() == 'n'
                      "
                      (click)="answerRbAppE(acs.indexOf(ac), 'n')"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
              }
              }
              @if (showSecondLevelScreening && (!row.ac || (row.ac.answerQ == 'Y' && row.ac.rbSectKey > 0 && (row.ac.exemption == null || row.ac.answerE.toLocaleString() == 'n')))) {
              <app-paragraph-checklist
                [rbSectKey]="row.rbSectKey"
                [csskey]="csskey"
                [appkey]="appkey"
                [editable]="editable"
              >
              </app-paragraph-checklist>
              }
            </mat-card-content>
          </mat-card>
        </mat-card-content>
        }
        <mat-card-footer class="bottomPad">
          <div class="hint"></div>
        </mat-card-footer>
      </mat-card>
      }
      }
      }
    </div>
  </div>
  }
</div>
